import { ReactNode, useMemo } from 'react';

import { AbilityContext, getAbilityContextDefault } from '@/setup/casl';

type AbilityProviderProps = { children: ReactNode };

export const AbilityProvider = ({ children }: AbilityProviderProps) => (
  <AbilityContext.Provider value={useMemo(() => getAbilityContextDefault(), [])}>{children}</AbilityContext.Provider>
);
